import firestore from './firebaseConfig';
const categoriesRef = firestore.collection('categories')


export function getCategories() {
    return categoriesRef.orderBy('order')
        .get().then(snapshot => {
            const categories = []
            snapshot.forEach(doc => {
                categories.push({
                    id: doc.id,
                    ...doc.data(),
                })
            })
            return categories
        })
}

export function updateCategories(newCategories) {
    return getCategories().then(oldCategories => {
        let toDelete = {}
        for(let category of oldCategories) {
            toDelete[category.id] = true
        }
        for(let category of newCategories) {
            delete toDelete[category.id]
        }
        return toDelete
    }).then(toDelete => {
        let promises = []
        for (let id in toDelete) {
            promises.push(categoriesRef.doc(id).delete())
        }
        return Promise.all(promises)
    }).then(() => {
        return Promise.all(newCategories.map((category, order) => {
            return categoriesRef.doc(category.id).set({
                name: category.name,
                order,
            })
        }))
    })
}

export const store = {categories: []}
getCategories().then(categories => store.categories = categories)

export const STYLES = [{
  type: 'light',
  color: '#D12229',
},{
  type: 'light',
  color: '#F68A1E',
},{
  type: 'full',
  color: '#FDE01A',
},{
  type: 'light',
  color: '#007940',
},{
  type: 'full',
  color: '#00c0c0',
},{
  type: 'light',
  color: '#4B0082',
}]